import { Link } from "react-router-dom";
import styled from "styled-components";
import { AiFillMinusCircle } from "react-icons/ai";
import { FiMinusCircle } from "react-icons/fi";

export const AppContainer = styled.div`
  width: 100%;
  padding-top: 8vh;
  padding-bottom: 4px;
  height: 94vh;
  overflow-y: auto;
`;

export const Services = styled.div``;

export const Solicitar = styled(Link)`
  padding: 0.35rem 1rem;
  text-decoration: none;
  border-radius: 7px;
  color: #fff;
  display: flex;
  margin: 0 auto;
  gap: 6px;
  margin-top: 20px;
  margin-bottom: 15px;
  border: 1px solid white;
  background: #3948ff;
  &:hover {
    text-decoration: none;
    background-color: #3948ff;
    border-color: #3948ff;
    color: white;
  }
`;

export const Wrapper = styled.div`
  width: 95% !important;
  margin: auto;
  display: grid;
  grid-template-columns: 20% 80%;

  @media (max-width: 1024px) {
    display: grid;
    grid-template-columns: 20% 100%;
    height: 100%;
    /* overflow-y: auto; */
  }
`;

export const LinkToCreateRequest = styled(Link)`
  display: flex;
  flex-direction: row-reverse;
  color: #3c6ebe;
`;

export const DDwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const DropDownContainer = styled.div`
  width: 10.5em;
  margin: 1;
`;

export const DropDownHeader = styled.div``;

export const DropDownListContainer = styled.div``;

export const DropDownList = styled.div``;

export const ListItem = styled.div``;

export const AppInnerContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 75%;
  padding-bottom: 4px;
  height: 100%;

  @media (min-width: 1024px) {
    width: 80%;
  }

  @media (max-width: 640px) {
    width: 95%;
    padding-right: 1rem;
    padding-left: 1rem;
    font-size: 14px;
  }
`;

export const CustomLink = styled(Link)`
  &:hover {
    background: ${(props) => props.bg};
  }
`;

export const ArticlesTitleLink = styled(Link)`
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 20px;
  color: #3c6ebe;
`;

export const Destacados = styled(Link)`
  display: flex;
  margin-top: 0.5rem;
  gap: 8px;
  align-items: center;
  color: black;
  font-weight: lighter;

  &:hover {
    color: #3c6ebe;
    text-decoration: underline;
  }

  /* className="my-1 flex gap-2 items-center" */
`;

export const HomeSearch = styled.input`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #dce6e6;

  &:focus {
    border-color: #dce6e6;
  }
`;

export const Card = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
  background-color: #def3ff;
  // &:hover {
  //   background-color: ${(props) => props.bg};
  // }

  // @media (max-width: 640px) {
  //   width: 95%;
  // }
`;

export const RemoveButton = styled(FiMinusCircle)`
  color: #757371;
  font-size: 1.5rem;

  @media (max-width: 640px) {
    font-size: 1.1rem;
  }
`;

export const RemoveButtonHover = styled(AiFillMinusCircle)`
  color: #3948ff;
  font-size: 1.5rem;

  @media (max-width: 640px) {
    font-size: 1.1rem;
  }
`;
